import { useDispatch, useSelector } from 'react-redux';
import {PartyLedgerListSearchComponent} from './PartyLedgersListSearchComponent'
import { useEffect } from 'react';
import { toggleChecked } from 'src/store/balanceShow/actions';

const PartyLedgerListHeader = ({
  senderId,
  setSenderId,
  receiverId,
  setReceiverId,
  alterNative,
  setAlterNative,
  partyId,
  setPartyId,
  setApiTotals,
  setIsCheckboxChecked,
  setSelectedRows,
}: any) => {
  console.log("id of sender",partyId);

  return (
    <div className='card-header d-block p-5' style={{zIndex: '99'}}>
      <PartyLedgerListSearchComponent
        senderId={senderId}
        setSenderId={setSenderId}
        receiverId={receiverId}
        setReceiverId={setReceiverId}
        alterNative={alterNative}
        setAlterNative={setAlterNative}
        partyId={partyId}
        setPartyId={setPartyId}
        setApiTotals={setApiTotals}
        setIsCheckboxChecked={setIsCheckboxChecked}
        setSelectedRows={setSelectedRows}
      />
    </div>
  )
}

export {PartyLedgerListHeader}
